import { publicApi } from "../api/axios";

/* ===============================
   GET ALL TESTIMONIALS (PUBLIC)
================================ */
export const getAllTestimonials = async () => {
  const { data } = await publicApi.get(
    "/testimonial/active-testimonials",
  );
  return data;
};
/* ===============================
   GET ALL INDUSTRY LEADERS LOGO (PUBLIC)
================================ */
export const getAllIndustryLeaders = async () => {
  const { data } = await publicApi.get("/industry-leaders/active-leaders");
  return data;
};
/* ===============================
   CAREER PAGE API'S
================================ */

// --------------- Current Jobs --------------------
export const getAllJobs = async () => {
  // const { data } = await publicApi.get("/opportunities?type=job");
  const { data } = await publicApi.get("/opportunities/current-openings");
  return data;
};

export const jobApply = async (payload) => {
  const { data } = await publicApi.post("/application", payload);
  return data;
};

// --------------- Create Message --------------------
export const createMessage = async (payload) => {
  const { data } = await publicApi.post("/messages", payload);
  return data;
};

/* ===============================
   PORTFOLIO PAGE API'S
================================ */

export const getPortfolioProjects = async (params = {}) => {
  const { data } = await publicApi.get("/portfolio/projects/active-projects", { params });
  return data;
};

export const getPortfolioCategories = async () => {
  const { data } = await publicApi.get("/portfolio/projects/categories");
  return data;
};

export const getPortfolioTechStack = async () => {
  const { data } = await publicApi.get("/portfolio/tech-stack/active-tech-stack");
  return data;
};

/* ===============================
   CONTACT DETAILS (PUBLIC)
================================ */

export const getContactDetails = async () => {
  const { data } = await publicApi.get("/contact");
  return data;
};
